import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { images } from "./images";

import { mc } from "../characters/MC";
import { ann } from "../characters/Ann";
import { doImageShake, doTransition, doWaitImageByTime } from "../helpers/helpers";
import { hobo } from "../characters/Hobo";
import { V8AnnCorruptionAlleyAfter } from "./V8";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";

const v8 = images.v8;
export const V8AnnCorruptionAlley = async (): Promise<any> => {
    doTransition(v8.V8AnnMCAlley_20);
    mc.talk(`Today was definitely something...`);
    ImageClass.setImage(images.v8.V8AnnMCAlley_20.partials.V8AnnMCAlley_20_p);
    ann.talk(`Hehe, it was a really busy day.`);
    doWaitImageByTime(v8.V8AnnMCAlley_21);
    mc.talk(`Let's cut through here, I know a shortcut.`);

    doTransition(v8.V8AnnMCAlley_22);
    ann.talk(`Oh no... This guy again.`, { method: "Whispering" });

    if (Question.globalAnswers.v4ToldAnnTeaseHobo) {
        mc.talk(`You were too scared to tease him after Joey's birthday.`, { method: "Whispering" });
        ann.talk(`Yeah because... Look at him.`, { method: "Whispering" });
    } else {

    }
    await mc.setQuestion(new Question({ text: `I wonder...`, options: { think: true }, key: `v8AnnAlleyUseAnnTeaseHobo` })
        .option({ title: `Use Ann to tease him`, key: true })
        .option({ title: `Just leave`, key: false }));


    if (Question.globalAnswers.v8AnnAlleyUseAnnTeaseHobo) {
        return jump(V8AnnCorruptionAlley_Tease, "V8AnnCorruptionAlley_Tease");
    }

    mc.talk(`Let's just go. I'll walk you home before going to my place.`, { method: "Whispering" });
    return jump(V8AnnCorruptionAlley_End, "V8AnnCorruptionAlley_End");
};
export const V8AnnCorruptionAlley_Tease = async (): Promise<any> => {
    //ImageClass.setImage(images.TODO_IMAGE)
    mc.talk(`Hold on, don't move.`, { method: "Whispering" });
    doWaitImageByTime(v8.V8AnnMCAlley_2);
    ann.talk(`${mc.name}? What are you planning?`, { method: "Whispering" });
    mc.talk(`Let's just have some fun with him.`, { method: "Whispering" });
    doWaitImageByTime(v8.V8AnnMCAlley_3);
    mc.talk(`YO!`, { method: "Shouting" });
    doWaitImageByTime(v8.V8AnnMCAlley_22);
    mc.talk(`WAKE UP!`, { method: "Shouting" });
    doWaitImageByTime(v8.V8AnnMCAlley_0);
    hobo.talk(`Huh?`);
    ann.talk(`He is awake.`, { method: "Whispering" });
    ann.talk(`...`);
    doWaitImageByTime(v8.V8AnnMCAlley_6);
    ann.talk(`He is...`, { method: "Whispering" });
    await ann.setQuestion(new Question({ text: `He is touching himself...`, options: { think: false, method: "Whispering" }, key: `v8AnnAlleyUseAnnTeaseHoboRemovedSkirt` })
        .option({ title: `Continue`, key: true })
        .option({ title: `That's enough (leave)`, key: false }));


    if (Question.globalAnswers.v8AnnAlleyUseAnnTeaseHoboRemovedSkirt) {
        doWaitImageByTime(v8.V8AnnMCAlley_7);
        mc.talk(`Let's try this...`, { method: "Whispering" });
        doWaitImageByTime(v8.V8AnnMCAlley_8, { wait: true });
        doWaitImageByTime(v8.V8AnnMCAlley_9);
        mc.talk(`That got him going.`, { method: "Whispering" });
        doWaitImageByTime(v8.V8AnnMCAlley_10);
        ann.talk(`${mc.name}...`, { method: "Whispering" });
        doWaitImageByTime(v8.V8AnnMCAlley_9);
        ann.talk(`${mc.name}!`, { method: "Whispering" });
        doWaitImageByTime(v8.V8AnnMCAlley_11);
        await ann.setQuestion(new Question({ text: `He is getting closer!`, options: { think: false, method: "Whispering" }, key: `v8AnnAlleyUseAnnTeaseHoboRemovedPanties` })
            .option({ title: `Remove her Panties`, key: true })
            .option({ title: `That's enough (leave)`, key: false }));


        if (Question.globalAnswers.v8AnnAlleyUseAnnTeaseHoboRemovedPanties) {
            doWaitImageByTime(v8.V8AnnMCAlley_12, { wait: true });
            doWaitImageByTime(v8.V8AnnMCAlley_13);
            ann.talk(`${mc.name}, are you... Sure about this?`, { method: "Whispering" });
            mc.talk(`Let's just see what he'll do.`, { method: "Whispering" });
            doImageShake(v8.V8AnnMCAlley_14);
            ann.talk(`${mc.name.toLocaleUpperCase()}!`);
            doWaitImageByTime(v8.V8AnnMCAlley_15, { wait: true });
            doWaitImageByTime(v8.V8AnnMCAlley_16);
            mc.talk(`Ok that's enough!`);
            ImageClass.setImage(images.v8.V8AnnMCAlley_17);
            hobo.talk(`Ahh!!!`);
            ImageClass.setImage(images.v8.V8AnnMCAlley_18);
            ann.talk(`Is he... Okay?`);
            ImageClass.setImage(images.v8.V8AnnMCAlley_19);
            mc.talk(`Yes, he is just excited. Let's give him some privacy.`);

            await endReplay(replayScenesList.v8annMCAlley);
        }


    }
    if (!Question.globalAnswers.v8AnnAlleyUseAnnTeaseHoboRemovedPanties) {

        mc.talk(`That's enough let's go.`);
    }

    return jump(V8AnnCorruptionAlley_End, "V8AnnCorruptionAlley_End");
};
export const V8AnnCorruptionAlley_End = async (): Promise<any> => {
    await endReplay();
    return jump(V8AnnCorruptionAlleyAfter, "V8AnnCorruptionAlleyAfter");
};